module.exports = __webpack_public_path__ + "static/media/siren-on.87bf2bba.svg";